export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/car-finance.68541a0f.svg","height":116,"width":133,"blurWidth":0,"blurHeight":0};